/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Sep 11 2023
 **/

import { css, keyframes } from "@emotion/react";

import { ZIndex } from "@/frameworks/core/commons";

import { SidebarOption } from "./Sidebar";

export const SidebarCss = (depth: number) => css`
	z-index: ${ZIndex.SIDEBAR - depth};
`;

export const drawerAnimationCss = (option: SidebarOption, isOpen?: boolean) => css`
	position: absolute;
	transition: 0.5s cubic-bezier(0.2, 0, 0, 1);
	${(() => {
		return `${option.direction}: ${option.startX}`;
	})()};
	transform: ${(() => {
		if (option.direction === "left") {
			return `translateX(${isOpen ? "0px" : `calc(-${option.startX} - ${option.width})`});`;
		}
		return `translateX(${isOpen ? `0px` : `calc(${option.startX} + ${option.width})`});`;
	})()};
	width: ${option.width};
	background: rgba(255, 255, 255, 0.94);
	backdrop-filter: blur(14px);
	height: 100%;

	> div {
		${isOpen !== undefined && drawerCss(isOpen, option.direction)}
	}
`;

const openRightKeyframe = keyframes`
	from {
		box-shadow: none;
	}
	to {
		box-shadow: -12px 0px 20px rgba(0, 0, 0, 0.16);
	}
`;

const closeRightKeyframe = keyframes`
	from {
		box-shadow: -12px 0px 20px rgba(0, 0, 0, 0.16);
	}
	to {
		box-shadow: none;
	}
`;

const openLeftKeyframe = keyframes`
	from {
		box-shadow: none;
	}
	to {
		box-shadow: 12px 0px 20px rgba(0, 0, 0, 0.16);
	}
`;

const closeLeftKeyframe = keyframes`
	from {
		box-shadow: 12px 0px 20px rgba(0, 0, 0, 0.16);
	}
	to {
		box-shadow: none;
	}
`;

const drawerCss = (isOpen: boolean, direction: "left" | "right") => css`
	animation: ${isOpen
			? direction === "left"
				? openLeftKeyframe
				: openRightKeyframe
			: direction === "left"
				? closeLeftKeyframe
				: closeRightKeyframe}
		0.3s ease-in-out forwards;
`;
